// extracted by mini-css-extract-plugin
export var columnList = "_ag-0";